import * as React from "react";
import { ButtonSize, ButtonState, ButtonVariant, SudoButton } from "./SudoButton";
import { SudoTooltip } from "./SudoTooltip";

export type TooltipButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  tooltip: string;
  tooltipPosition?: import("@floating-ui/react").Placement;
  tooltipDelay?: number;
  tooltipDisabled?: boolean;
  variant?: ButtonVariant;
  size?: ButtonSize;
  state?: ButtonState;
  loadingPercentage?: number;
  iconSize?: number;
  leftIcon?: string;
  rightIcon?: string;
  loadingTransitionDuration?: number;
  className?: string;
  as?: React.ElementType;
};

export const TooltipButton = React.forwardRef<HTMLButtonElement, TooltipButtonProps>(
  (
    {
      tooltip,
      tooltipPosition = "bottom",
      tooltipDelay = 150,
      tooltipDisabled = false,
      children,
      variant = "primary",
      size,
      state,
      loadingPercentage,
      iconSize,
      leftIcon,
      rightIcon,
      loadingTransitionDuration,
      className,
      as,
      ...buttonProps
    },
    ref
  ) => {
    const button = (
      <SudoButton
        ref={ref as any}
        variant={variant}
        size={size}
        state={state as any}
        loadingPercentage={loadingPercentage}
        iconSize={iconSize}
        leftIcon={leftIcon}
        rightIcon={rightIcon}
        loadingTransitionDuration={loadingTransitionDuration}
        className={className}
        as={as as any}
        {...buttonProps}
      >
        {children}
      </SudoButton>
    );

    if (!tooltip || tooltipDisabled) return button;

    return (
      <SudoTooltip
        text={tooltip}
        position={tooltipPosition}
        delay={tooltipDelay}
      >
        {button}
      </SudoTooltip>
    );
  }
);

TooltipButton.displayName = "TooltipButton";
